/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_RentInputs */

const cs_enum_rent = /** @type {(inputs: Enum_RentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronájem`)
};

const en_enum_rent = /** @type {(inputs: Enum_RentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rent`)
};

/**
* | output |
* | --- |
* | "Rent" |
*
* @param {Enum_RentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_rent = /** @type {((inputs?: Enum_RentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_RentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_rent(inputs)
	return cs_enum_rent(inputs)
});